import { Component, inject, ViewEncapsulation } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-session-expiration-dialog',
  standalone: true,
  imports: [ButtonModule, DialogModule],
  templateUrl: './session-expiration-dialog.component.html',
  styleUrl: './session-expiration-dialog.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class SessionExpirationDialogComponent {
  ref = inject(DynamicDialogRef);
  auth = inject(AuthService);
  logout() {
    this.ref.close('logout');
  }

  extend() {
    this.ref.close('extend');
  }
}
